import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import FieldsGroup from '../../layouts/common/FieldsGroup';
import MatureCheckboxField from '../../fields/newLabelOptions/MatureCheckboxField';
import NoAiCheckboxField from '../../fields/newLabelOptions/NoAiCheckboxField';
import CreatedWithAiCheckboxField from '../../fields/newLabelOptions/CreatedWithAiCheckboxField';
import HorizontalSeparator from '../../layouts/common/HorizontalSeparator';
import { SubmitFormContext } from '../../context';

import s from './LabelOptionsForm.scss';

interface Props {}

const LabelOptionsForm: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { initResponse } = useContext(SubmitFormContext) || {};
  const isDreamup = !!initResponse?.deviation?.extended?.dreamsofart;

  return (
    <div>
      {isDreamup && <HorizontalSeparator margins="both" />}
      <FieldsGroup
        className={s['root']}
        title={
          <>
            {t('deviationSubmit.form.section.labelOptions.title')}
            <SimpleTooltip
              usePortal
              containerClassName={s['tooltip']}
              placement="top"
              text={
                <>
                  {t(
                    'deviationSubmit.form.section.labelOptions.infoTooltip.text'
                  )}
                  <br />
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={t(
                      'deviationSubmit.form.section.labelOptions.infoTooltip.URL'
                    )}
                    className={'link'}
                  >
                    {t('common.learnMore')}
                  </a>
                </>
              }
            >
              <InfoIcon
                size={IconSize.SMALLER}
                className={s['icon']}
                disableDefaultColors
              />
            </SimpleTooltip>
          </>
        }
      >
        <MatureCheckboxField noBottomSpacing={isDreamup} />
        <NoAiCheckboxField noBottomSpacing={isDreamup} />
        <CreatedWithAiCheckboxField noBottomSpacing={isDreamup} />
      </FieldsGroup>
      {isDreamup && <HorizontalSeparator margins="both" />}
    </div>
  );
};
LabelOptionsForm.displayName = 'LabelOptionsForm';

export default LabelOptionsForm;
